import { render, staticRenderFns } from "./ItemStatusComponent.vue?vue&type=template&id=85244f3c&scoped=true"
import script from "./ItemStatusComponent.vue?vue&type=script&lang=js"
export * from "./ItemStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85244f3c",
  null
  
)

export default component.exports